import { Injectable } from '@angular/core';
import { NeptuneApi } from '../genericApi/neptune.api';
import { Observable } from 'rxjs';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { G2TokenApiModel } from './models/g2-token-api.model';

@Injectable()
export class G2Api {

    constructor(
        private neptuneApi: NeptuneApi
    ) {}

    /**
     * Get source list
     */
    getOneTimeToken(): Observable<G2TokenApiModel> {
        // ProductID is not a secret value, it's available on their public website
        return this.neptuneApi.api<G2TokenApiModel>(
            '/g2/reviews?productId=aae9bf93-2169-466c-bd13-cf0b4988559b',
            {},
            HttpVerbsEnum.POST
        );
    }
}
